module.exports = __webpack_public_path__ + "static/media/rowing.6eedf827.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/rowing.png
// module id = 1707
// module chunks = 1